import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidaciesMinimalQueryKey } from "@/hooks/queries/useGetCandidaciesMinimal";

export const useRefetchCandidaciesMinimal = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return () => {
    void queryClient.refetchQueries({
      queryKey: candidaciesMinimalQueryKey(currentCompanyId, currentJobId),
    });
  };
};
